<template>
    <div id="coin-game" class="game" :data-coin="coin_type">
        <router-link to="/" tag="div" class="close">×</router-link>
        <h1>Heads or tails</h1>
        <form class="game-wrapper layout-1" @submit="play">
            <ul id="coins-results">
                <li v-for="(r,i) of results" v-bind:key="i">{{ r ? 1 : 0 }}</li>
            </ul>
            <div id="gl-container"></div>
            <div class="layout-navigation">
                <button class="action-button" :disabled="!!rotation_x_destination_deg">Flip the coin</button>
            </div>
        </form>
    </div>
</template>

<script>

  import Random from './../utils/random'
  import * as THREE from 'three'
  import COINS from './../coins.json'

  const createCylinder = (radiusTop, radiusBottom, height, radialSegments, heightSegments, coin_type) => {
    const cylinder = new THREE.Object3D()

    const sidesGeo = new THREE.CylinderGeometry(
      radiusTop,
      radiusBottom,
      height,
      radialSegments,
      heightSegments,
      true
    )

    const sidesMat = new THREE.MeshBasicMaterial({color: parseInt(COINS[coin_type].color)})
    const sidesMesh = new THREE.Mesh(sidesGeo, sidesMat)
    cylinder.add(sidesMesh)

    const capTopGeo = new THREE.CircleGeometry(radiusTop, radialSegments)
    const capTopTexture = new THREE.TextureLoader().load(COINS[coin_type].top)
    const capTopMat = new THREE.MeshBasicMaterial({color: 0xffffff, map: capTopTexture})
    const capTopMesh = new THREE.Mesh(capTopGeo, capTopMat)
    capTopMesh.position.y = height / 2
    capTopMesh.rotation.x = -Math.PI / 2
    cylinder.add(capTopMesh)

    const capBottomGeo = new THREE.CircleGeometry(radiusBottom, radialSegments)
    const capBottomTexture = new THREE.TextureLoader().load(COINS[coin_type].bottom)
    const capBottomMat = new THREE.MeshBasicMaterial({color: 0xffffff, map: capBottomTexture})
    const capBottomMesh = new THREE.Mesh(capBottomGeo, capBottomMat)
    capBottomMesh.position.y = -height / 2
    capBottomMesh.rotation.x = Math.PI / 2
    cylinder.add(capBottomMesh)

    return cylinder
  }

  const deg2rad = (deg) => {
    return Math.PI / 180 * deg
  }

  export default {
    data: function () {
      return {
        'rotation_x_destination_deg': null,
        'rotation_x_position': 0,
        'rotation_x_basic_deg': 90,
        'coin': null,
        'results': [],
        'result': true,
      }
    },
    props: ['coin_type'],
    mounted: function () {
      if (!COINS.hasOwnProperty(this.$props.coin_type)) {
        alert('This coins not found');
        return;
      }

      const game_container_size = document.getElementById('coin-game').getBoundingClientRect()
      const scene = new THREE.Scene()

      const camera = new THREE.PerspectiveCamera(35, game_container_size.width / game_container_size.height, 0.15, 1000)

      const renderer = new THREE.WebGLRenderer({'antialias': true, 'alpha': true})
      renderer.setSize(game_container_size.width, game_container_size.height)
      document.getElementById('gl-container').appendChild(renderer.domElement)

      const coin = createCylinder(0.75, 0.75, 0.15, 64, 64, this.$props.coin_type)
      scene.add(coin)

      const animate = () => {
        requestAnimationFrame(animate)
        if (this.$data.rotation_x_destination_deg) {
          const rotation_x_destination = deg2rad(this.$data.rotation_x_destination_deg)
          const mm = coin.rotation.x / rotation_x_destination
          let m = (0.5 - Math.abs(mm - 0.5)) / 0.5
          let new_rotation_x = coin.rotation.x + deg2rad(20 - mm * 5)
          coin.position.z = -5 * m
          coin.position.y = 1.5 * m
          coin.rotation.y -= deg2rad(2 - mm * 1.5)
          if (new_rotation_x >= rotation_x_destination) {
            this.$data.rotation_x_basic_deg = this.$data.rotation_x_destination_deg % 360
            coin.rotation.x = deg2rad(this.$data.rotation_x_basic_deg)
            this.$data.results.unshift(this.$data.result)
            this.$data.rotation_x_destination_deg = null
          } else {
            coin.rotation.x = new_rotation_x
          }
        }
        renderer.render(scene, camera)
      }

      coin.rotation.x = deg2rad(this.$data.rotation_x_basic_deg)
      animate()

      camera.position.z = 5

      this.$data.coin = coin
      this.$data.scene = scene
      this.$data.renderer = renderer
      this.$data.camera = camera
    },
    methods: {
      play: function (e) {
        e.preventDefault()
        const n = Random.getNumber(9, 12)
        const change = !!(n % 2);
        this.$data.result = change ? !this.$data.result : this.$data.result;
        this.$data.rotation_x_destination_deg = this.$data.rotation_x_basic_deg + 180 * n
      }
    }
  }
</script>

<style src="./../assets/css/game.css" scoped></style>
<style scoped>

    canvas {
        display: block;
    }

    #coin-game {
        background: #d59a5c url('../assets/img/game/coin/bg.jpg') 50% 25%;
        background-size: cover;
        overflow: hidden;
    }

    #coin-game[data-coin="quarter"] {
        background-image: url('../assets/img/game/coin/bg-quarter.jpg');
    }

    #coin-game[data-coin="10-rubles"] {
        background-image: url('../assets/img/game/coin/bg-10-rubles.jpg');
    }

    #coin-game[data-coin="2-nis"] {
        background-image: url('../assets/img/game/coin/bg-2-nis.jpg');
    }

    #coin-game[data-coin="2-euro"] {
        background-image: url('../assets/img/game/coin/bg-2-euro.jpg');
    }

    #coins-results {
        position: absolute;
        top: 4rem;
        left: 1rem;
    }

    #coins-results > li {
        color: #808080;
        background: #e5e5e5;
        border: 0.25rem solid #808080;
        display: block;
        width: 2rem;
        height: 2rem;
        line-height: 2rem;
        text-align: center;
        font-weight: bold;
        font-size: 1.5rem;
        margin-bottom: 0.5rem;
        border-radius: 2rem;
        opacity: 0.5;
    }

    #coins-results > li:first-child {
        opacity: 1;
    }

</style>
